// Func = limiting Scope for this file
var lastScrollTop = 0
;(function () {
  $(document).ready(function () {
    $('.carousel-expand').slick({
      infinite: true,
      slidesToShow: 3,
      arrows: true,
      slidesToScroll: 1,
    })
    // Main Nav Dropdown
    $('#primary-nav li').hover(
      function () {
        $(this).addClass('hover')
        $('ul.submenu', this).fadeIn(200)
      },
      function () {
        $(this).removeClass('hover')
        $('ul.submenu', this).fadeOut(200)
      },
    )

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true]
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = 'highlight-top'
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = 'highlight'
      } else {
        DATE_STYLE[1] = ''
      }
      return DATE_STYLE
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format')
        ? $('#CheckIn').data('format')
        : 'dd-M-y'
    $('#CheckIn').datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker('getDate')
        let newDate = new Date(getDate.getTime())
        newDate.setDate(newDate.getDate() + 3)
        $('#CheckOut').datepicker('setDate', newDate)
        $('#CheckOut').datepicker('option', 'minDate', selectedDate)
      },
    })
    $('#CheckOut').datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    })
    
    let opened = 0;
		let start = $('#CheckIn').val();
		let end = $('#CheckOut').val();

		$('#calendars_booking').datepicker({
			showOn: "both",
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 2,
			dayNamesMin: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
			monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			minDate: 0,
			beforeShowDay: function (date) {
				let startDate = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
				let endDate = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());

				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else if (date.getTime() == endDate.getTime()) {
					return [true, "endday"];
				} else if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
					return [true, "days"];
				} else {
					return [true, ""];
				}
			},
			onSelect: function (date) {
				let arrive = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
				let departure = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
				let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				}

				$('#CheckIn').attr("value", start);
				$('#CheckOut').attr("value", end);
				
				let startDateJS = new Date(start),
					endDateJS = new Date(end),
					checkInInputReadOnly = document.querySelector(`#CheckIn-readonly`),
					checkOutInputReadOnly = document.querySelector(`#CheckOut-readonly`);

				let startDateFormatedAsOB = {
					day: startDateJS.getDate() < 10 ? '0'+startDateJS.getDate() : startDateJS.getDate(),
					month: startDateJS.getMonth() + 1,
					year: startDateJS.getFullYear()
				};
				let endDateFormatedAsOB = {
					day: endDateJS.getDate() < 10 ? '0'+endDateJS.getDate() : endDateJS.getDate(),
					month: endDateJS.getMonth() + 1,
					year: endDateJS.getFullYear()
				};

				checkInInputReadOnly.value = `${startDateFormatedAsOB.month < 10 ? '0'+startDateFormatedAsOB.month : startDateFormatedAsOB.month }/${startDateFormatedAsOB.day}/${startDateFormatedAsOB.year}`;
				checkOutInputReadOnly.value = `${endDateFormatedAsOB.month < 10 ? '0'+endDateFormatedAsOB.month : endDateFormatedAsOB.month }/${endDateFormatedAsOB.day}/${endDateFormatedAsOB.year}`;
				

			}
		});

    $('#booking-form').submit(function (event) {
      event.preventDefault()
      var destinationUrl = $(this).attr('action')
      var str = $(this).serialize()
      var fullUrl = destinationUrl + '?' + str
      console.log({ fullUrl })

      if(!city_options.classList.contains('hidden') ){
        if(document.querySelector('.js-airport-error').classList.contains('hidden')){
          ga(function (tracker) {
            var linker = new window.gaplugins.Linker(tracker)
            var output = linker.decorate(fullUrl, true)
            ga('send', 'event', 'header widget', 'click', 'book now')
            window.open(output, '_blank')
          })
        }
      }else if(city_options.classList.contains('hidden')){
        ga(function (tracker) {
          var linker = new window.gaplugins.Linker(tracker)
          var output = linker.decorate(fullUrl, true)
          ga('send', 'event', 'header widget', 'click', 'book now')
          window.open(output, '_blank')
        })
      }

    })
  })

  let homepage = document.getElementById('home')

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
    if (homepage != null) {
      if ($(window).width() > 600) {
        scrollDownAction(20, 'scroll')
      }
    }

    scrollW()
    window.addEventListener('scroll', function () {
      scrollW()
    })
  }
})()

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById('header').classList.contains('down')) {
        document.getElementById('header').classList.add('down')
        document.getElementById('header').classList.remove('up')
      }
    } else {
      // upscroll code
      if (!document.getElementById('header').classList.contains('up')) {
        document.getElementById('header').classList.add('up')
        document.getElementById('header').classList.remove('down')
      }
    }
  } else {
    if (
      document.getElementById('header').classList.contains('up') ||
      document.getElementById('header').classList.contains('down')
    ) {
      document.getElementById('header').classList.remove('up')
      document.getElementById('header').classList.remove('down')
    }
  }
  lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}
